<template>
	<div class="hello">
		<h1>用于测试各种小东西</h1>
		<!-- 权限节点树形表 -->
		<div>
			<dl :key="i" v-for="(list,i) in treedata">
				<dt>
					<i :class="list.checked?'half-line fl list-toggle-icon':'fl list-toggle-icon'"
						@click="iconclick(list)">-</i>
					<span class="fl check-name">{{list.name}}</span>
					<el-checkbox-group v-model="list.checkList" class="fl check-box-div">
						<el-checkbox label="view"></el-checkbox>
						<el-checkbox label="edit"></el-checkbox>
					</el-checkbox-group>
				</dt>
				<dd :key="index" v-for="(item,index) in list.children"
					:class="index == (list.children.length-1) ? 'half-line':'full-line'" v-show="list.checked">
					<span class="fl check-name">{{item.name}}</span>
					<el-checkbox-group v-model="item.checkList" class="fl check-box-div">
						<el-checkbox label="view"></el-checkbox>
						<el-checkbox label="edit"></el-checkbox>
					</el-checkbox-group>
				</dd>
			</dl>
			<el-button @click="getdatalist()">点我看看数据格式</el-button>
		</div>
		<el-button @click="openInterview=true">点开预约时间弹框</el-button><el-button @click="openOfferInfor=true">点开job发邮件弹框</el-button>
		<el-dialog  
					:visible.sync="openInterview" 
					@close="openInterview = false"
					:lock-scroll="true"
					:top="'8vh'"
					@open="formOpen" 
					class="dialog-no-title"
					width="70%"
					>
			<h2 class="card-interview-title">Propose date & time for interview</h2>
			<el-form ref="interviewForm" :rules="interviewRule" :model="interviewForm" :label-position="labelPosition" label-width="100px"  class="employer-ruleForm interview-line">  
			<el-form-item label="鹌鹑蛋" prop="time1">
				<div style="width:100%;height:auto;border:1px solid #eee;overflow: hidden;" class="date-montage-time">
					<el-date-picker
							prefix-icon="el-icon-date"
							v-model="interviewFormList.time1.date"
							:picker-options="pickerOptions"
							type="date" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd"
							placeholder="选择时间" class="interview-time-date fl border-none" style="width:140px" @change="montageDateTime('time1')"> 
					</el-date-picker>
					<el-time-select clearable style="width:100px" @change="montageDateTime('time1')" class="fl" prefix-icon="el-icon-time border-none" placeholder="选择时间" v-model="interviewFormList.time1.time" 
					format="HH:mm" value-format="HH:mm" :picker-options="timePickOptions">
				</el-time-select>
			</div> 
			</el-form-item>
				<el-form-item label="1st Priority" prop="time1">
					 <el-date-picker
						prefix-icon="el-icon-date"
							v-model="interviewForm.time1"
							:picker-options="pickerOptions"
							type="datetime" clearable format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
							placeholder="选择日期时间" class="interview-time">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="2nd Priority" prop="time2">
					 <el-date-picker
						prefix-icon="el-icon-date"
					 		v-model="interviewForm.time2"
								:picker-options="pickerOptions"
					 		type="datetime" clearable format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
					 		placeholder="选择日期时间" class="interview-time">
					 </el-date-picker>
				</el-form-item>
				<el-form-item label="	3rd Priority" prop="time3">
					 <el-date-picker
							prefix-icon="el-icon-date"
					 		v-model="interviewForm.time3"
								:picker-options="pickerOptions"
					 		type="datetime" clearable format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
					 		placeholder="选择日期时间" class="interview-time">
					 </el-date-picker>
				</el-form-item>
				<el-button @click="summitInterviewDate('interviewForm')">提交预约日期时间</el-button>
			</el-form>
		</el-dialog>
		<el-dialog
					:visible.sync="openOfferInfor" 
					@close="openOfferInfor = false"
					:lock-scroll="true"
					:top="'8vh'"
					@open="formOpen" 
					class="dialog-no-title"
					width="70%"
					>
			<h2 class="card-interview-title">Job offer toNancy H23355</h2>
			<div class="interview-line" style=" height: 250px;background-color: #eee;"></div> 
			<el-checkbox class="interview-line" style="display: block;" @change="errortext=''" v-model="offerConfirm"><span style="display:inline-block;width:100%;height:auto;white-space:pre-wrap;">By checking this box, I understand the offer will be sent to the selected helper, offer cannot be with drawn and cannot send out other offer within3 days or until the offered helper declined the offer.</span></el-checkbox>
			<p class="errortext" v-show="errortext!=''">{{errortext}}</p>
			<el-button @click="submitOfferConfirm('offerConfirm')">提交确认发送offer</el-button>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {  
				treedata: [{
						"id": 1,
						"pid": 0,
						"node_us_name": "Dashboard",
						"node_cn_name": "仪表盘",
						"node_tw_name": "儀表板",
						"is_menu": 1,
						"sort": 0,
						"control_name": "Dashboard",
						"action_name": "index",
						"name": "Dashboard",
						"title": "Dashboard",
						"field": 1,
						"href": "",
						"checked": false,
						checkList: [],
						"children": []
					},
					{
						"id": 6,
						"pid": 0,
						"node_us_name": "222",
						"node_cn_name": "2222",
						"node_tw_name": "2222",
						"is_menu": 1,
						"sort": 200,
						"control_name": "#",
						"action_name": "#",
						"name": "222",
						"title": "222",
						"field": 6,
						"href": "",
						"checked": false,
						checkList: [],
						"children": [{
							"id": 11,
							"pid": 6,
							"node_us_name": "2111",
							"node_cn_name": "2111",
							"node_tw_name": "2111",
							"is_menu": 2,
							"sort": 0,
							"control_name": "2111",
							"action_name": "2111",
							"name": "2111",
							"title": "2111",
							"field": 11,
							"href": "",
							"checked": false,
							checkList: [],
							"children": [{
								"id": 16,
								"pid": 11,
								"node_us_name": "121212",
								"node_cn_name": "1212",
								"node_tw_name": "1212121212",
								"is_menu": 1,
								"sort": 200,
								"control_name": "121212",
								"action_name": "121212",
								"name": "121212",
								"title": "121212",
								"field": 16,
								"href": "",
								"checked": false,
								checkList: [],
								"children": []
							}]
						}, {
							"id": 18,
							"pid": 6,
							"node_us_name": "2111",
							"node_cn_name": "2111",
							"node_tw_name": "2111",
							"is_menu": 2,
							"sort": 0,
							"control_name": "2111",
							"action_name": "2111",
							"name": "9948",
							"title": "2111",
							"field": 11,
							"href": "",
							"checked": false,
							checkList: [],
							"children": [{
								"id": 16,
								"pid": 11,
								"node_us_name": "121212",
								"node_cn_name": "1212",
								"node_tw_name": "1212121212",
								"is_menu": 1,
								"sort": 200,
								"control_name": "121212",
								"action_name": "121212",
								"name": "121212",
								"title": "121212",
								"field": 16,
								"href": "",
								"checked": false,
								checkList: [],
								"children": []
							}]
						}, ]
					},
					{
						"id": 13,
						"pid": 0,
						"node_us_name": "3",
						"node_cn_name": "3",
						"node_tw_name": "3",
						"is_menu": 1,
						"sort": 300,
						"control_name": "#",
						"action_name": "#",
						"name": "3",
						"title": "3",
						"field": 13,
						"href": "",
						"checked": false,
						checkList: [],
						"children": []
					},
					{
						"id": 8,
						"pid": 0,
						"node_us_name": "4",
						"node_cn_name": "4",
						"node_tw_name": "4",
						"is_menu": 1,
						"sort": 400,
						"control_name": "#",
						"action_name": "#",
						"name": "4",
						"title": "4",
						"field": 8,
						"href": "",
						"checked": false,
						checkList: [],
						"children": [{
							"id": 10,
							"pid": 8,
							"node_us_name": "41",
							"node_cn_name": "41",
							"node_tw_name": "41",
							"is_menu": 1,
							"sort": 0,
							"control_name": "41",
							"action_name": "41",
							"name": "41",
							"title": "41",
							"field": 10,
							"href": "",
							"checked": false,
							checkList: [],
							"children": []
						}]
					}
				],
    openInterview:true,
    openOfferInfor:false,
    errortext:"",
				offerConfirm: false , 
				labelPosition:"left",
				interviewForm:{
					time1:"2023-12-22 10:00",time2:'2023-12-26 12:30',time3:"2023-12-20 08:30"
				},
				interviewFormList:{
					time1:{date:"",time:"",montage:""},
					time2:{date:"",time:"",montage:""},
					time3:{date:"",time:"",montage:""}, 
				},
				interviewRule: {
					time1: [{
						required: true,
						message: 'pleaseFillInput',
						trigger: 'blur'
					}],
					time2: [{
						required: true,
						message: 'pleaseFillInput',
						trigger: 'blur'
					}],
					time3: [{
						required: true,
						message: 'pleaseFillInput',
						trigger: 'blur'
					}],
				}, 
				pickerOptions: { 
					disabledDate(time) {
						return time.getTime() < Date.now();
					}, 
				},
				timePickOptions:{
					start: '00:00',
					step: '00:30',
					end: '23:30',
				},
			}
		},
		props: {
			msg: String
		},
		mounted() {
			for(var key in this.interviewForm){
				if(this.interviewForm[key]!= ''){
					let arry=this.interviewForm[key].split(' ');
					this.interviewFormList[key].date=arry[0];
					this.interviewFormList[key].time=arry[1];
				} 
			}
		},
		methods: {
			//日期 时间拼接上传
			montageDateTime(type){
				this.interviewForm[type]=this.interviewFormList[type].date+' '+this.interviewFormList[type].time;
			},
			//节点树下拉展示
			iconclick(list) {
				if (list.children.length > 0) {
					list.checked = !list.checked
				}
			},
			getdatalist() {
				console.log(this.data)
			},
			//时间预约
			formOpen(){
				
			}, 
			summitInterviewDate(formName){
				this.$refs[formName].validate((valid,object) => {
					if (valid) { 
						 console.log('表单验证通过',this.interviewForm);
							this.openInterview = false;
							this.interviewForm={time1:"",time2:'2023-11-12 12:30:20',time3:""};
					} else {
							console.log('表单验证不通过');//沒有滾動 因為只是個彈框
						return false;
					}
				});
			},
			submitOfferConfirm(formName){
				 if(this.offerConfirm){
						console.log('表单验证通过',this.offerConfirm);
						this.openOfferInfor = false;
						this.offerConfirm=false;
					}else{
						this.errortext='需要勾选才能提交';
					}
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.interview-time{
		width:100% !important;
	}
	.interview-line{
		width: 80%;margin: 0 auto !important;
		/* white-space: pre-wrap; */
	}
	h1 {
		font-size: 20px;
		line-height: 36px;
	}

	dl {
		padding: 20px 100px;
	}

	dt,
	dd {
		height: 36px;
		width: 100%;
		line-height: 36px;
		overflow: hidden;
	}

	dd {
		position: relative;
		padding-left: 30px;
		margin-left: 10px;
	}

	.fl {
		float: left;
	}

	dd::before {
		content: "";
		width: 25px;
		height: 1px;
		background: #aaa;
		position: absolute;
		left: 0;
		top: 16px;
	}

	.full-line::after {
		height: 36px;
	}

	dd::after {
		content: "";
		width: 1px;
		height: 16px;
		background: #aaa;
		position: absolute;
		left: 0;
		top: 0;
	}

	.check-name {
		width: 150px;
	}

	.list-toggle-icon {
		cursor: pointer;
		width: 20px;
		height: 20px;
		border: 1px solid #aaa;
		text-align: center;
		margin-right: 20px;
		line-height: 20px;
		position: relative;
		margin-top: 5px;
	}

	.list-toggle-icon.half-line::before {
		content: "";
		width: 1px;
		height: 15px;
		background: #aaa;
		position: absolute;
		left: 9px;
		bottom: -15px;
	}
	.border-none .el-input__inner{
		border:none;
	}
</style>